export default "__VITE_ASSET__BBjx8Gi9__"